define( function() {
	"use strict";

	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/rquery.js
// module id = 92
// module chunks = 0